import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as assetApi from '../../../../api/assets';
import { denormaliseData, normaliseData } from '../helpers';
import { IPortalPropertyPhotoAsset } from '../../../../interfaces/asset';

const useDeletePropertyPhoto = (nhID: number) => {
    const queryClient = useQueryClient();
    const queryKey = ['asset', 'photos'];
    
     return  useMutation({
            mutationFn: (assetID: number) => assetApi.deletePropertyPhoto(nhID, assetID),
            onMutate: async (assetID: number) => {
                // prevent any query updates while we perform optimistic update
                await queryClient.cancelQueries({ queryKey });
    
                // copy the current data as it exists in the react-query store
                const [previousKeyAndData]: any[] = queryClient.getQueriesData({
                    queryKey
                });
    
                const oldData = previousKeyAndData?.[1] || [];

                queryClient.setQueriesData({ queryKey }, (data: IPortalPropertyPhotoAsset[]) => {        
                    const normalisedData = normaliseData(data);
                    const propertyTagIDs = normalisedData.properties[nhID]?.tags;
                    propertyTagIDs?.forEach((tagID) => {
                        const tag = normalisedData.tags[tagID];
                        tag.photos = tag.photos.filter((photoID) => {
                            return photoID.toString() !== assetID.toString();
                        });
                    });
        
                    return denormaliseData(normalisedData);
                });
    
                return { previous: oldData };
            },
            onError: (error, _, context) => {
                console.log(error);
                // Rollback to the previous state if mutation fails
                if (context?.previous) {
                    queryClient.setQueryData(queryKey, context.previous);
                }
            },
            onSettled: () => {
                queryClient.invalidateQueries({
                    queryKey
                });
            }
        });
    
};

export { useDeletePropertyPhoto };